import { useState } from "react";
import "./PaymentForm.scss";
export default function PaymentForm({}) {
  return (
    <div class="payment-form">
      <h2>Оплата банковской картой</h2>
      <div class="card-type">
        <img src="https://upload.wikimedia.org/wikipedia/commons/b/b9/Mir-logo.SVG.svg" alt="Мир" />
      </div>
      <div class="form-group">
        <label for="card-number">Номер карты</label>
        <div class="card-number">
          <input type="text" maxlength="4" placeholder="XXXX" pattern="\d{4}" required />
          <input type="text" maxlength="4" placeholder="XXXX" pattern="\d{4}" required />
          <input type="text" maxlength="4" placeholder="XXXX" pattern="\d{4}" required />
          <input type="text" maxlength="4" placeholder="XXXX" pattern="\d{4}" required />
        </div>
      </div>
      <div class="form-group">
        <label for="card-holder">Имя владельца карты</label>
        <input type="text" id="card-holder" placeholder="IVAN IVANOV" required />
      </div>
      <div class="form-group expiry-cvv">
        <div>
          <label for="expiry">Срок действия</label>
          <input type="text" id="expiry" placeholder="MM/YY" pattern="\d{2}/\d{2}" required />
        </div>
        <div>
          <label for="cvv">CVV</label>
          <input type="text" id="cvv" maxlength="3" placeholder="123" pattern="\d{3}" required />
        </div>
      </div>
      <div class="form-group">
        <label for="amount">Сумма платежа</label>
        <input type="number" id="amount" placeholder="1000.00" step="0.01" required />
      </div>
      <button class="submit-btn" onclick="processPayment()">
        Оплатить
      </button>
    </div>
  );
}
